export default __webpack_public_path__ + "static/media/audios.75e18dcf.png";